import { Component, inject } from '@angular/core';
import { UIPreviewBannerService } from 'src/app/core/services/ui-preview/ui-preview-banner.service';
import { UIPreviewService } from 'src/app/core/services/ui-preview/ui-preview.service';

@Component({
  selector: 'ui-preview-banner',
  templateUrl: './ui-preview-banner.component.html'
})
export class UIPreviewBannerComponent {
  bannerService: UIPreviewBannerService;
  
  constructor() {
    inject(UIPreviewService);
    this.bannerService = inject(UIPreviewBannerService);
  }

  togglePreview() {
    this.bannerService.togglePreview();
  }
}
